import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectCustomerFirstName } from 'src/store/selectors/customerProfile'
import { selectSponsorshipFirstName } from 'src/store/selectors/sponsorship'
import {
  selectRefiRequested,
  selectRefiRequestSuccess,
  selectRefiRequestFailure
} from 'src/store/selectors/refinance'
import { sendRefiRequestForClient } from 'src/actions/refinance'

const RefiRequestContainer = compose(
  connect(
    state => ({
      contactFirstName:
        selectSponsorshipFirstName(state) || selectCustomerFirstName(state),
      requested: selectRefiRequested(state),
      success: selectRefiRequestSuccess(state),
      failure: selectRefiRequestFailure(state)
    }),
    dispatch => ({
      onRequestRefi: label => dispatch(sendRefiRequestForClient(label))
    })
  )
)

export default RefiRequestContainer
